<template>
  <div class="result1">
    <div class="phone" v-show="!isPc">
      <div v-if="!carInfo.yy">
        <div id="qrcode"></div>
        <!-- <img src="../assets/success.png" class="img" alt=""> -->
        <h3>{{ msg }}</h3>
        <p>提交人：{{ carInfo.tjr }}</p>
        <p>车架号：{{ carInfo.clsbdh }}</p>
        <p>发动机型号：{{ carInfo.fdjxh }}</p>
        <p>发动机号：{{ carInfo.fdjh }}</p>
        <p>排放标准：{{ carInfo.rdbz }}</p>
        <p>整车型号：{{ carInfo.zcxh }}</p>
        <p>
          注：该环保审核结果仅适用于转入苏州大市，如若该车辆迁出苏州，则此审核单失效，以迁入地的排放认定为准。
        </p>
      </div>
      <div v-if="carInfo.yy">
        <img src="../assets/叉.png" alt="" />
        <h3>已认定</h3>
        <p>原因：{{ carInfo.yy }}</p>
        <p>状态：{{ carInfo.zt }}</p>
        <button @click="resubmit" class="btn resubmit">重新提交</button>
      </div>
      <button @click="back" class="btn back">返回</button>
      <button @click="close" class="btn">关闭</button>
    </div>
    <div class="pc" v-show="isPc">
      <div v-if="!carInfo.yy">
        <div id="qrcode1"></div>
        <!-- <img src="../assets/success.png" class="img" alt=""> -->
        <h3>{{ msg }}</h3>
        <p>提交人：{{ carInfo.tjr }}</p>
        <p>车架号：{{ carInfo.clsbdh }}</p>
        <p>发动机型号：{{ carInfo.fdjxh }}</p>
        <p>发动机号：{{ carInfo.fdjh }}</p>
        <p>排放标准：{{ carInfo.rdbz }}</p>
        <p>整车型号：{{ carInfo.zcxh }}</p>
        <el-row>
          <el-col :span="15" :offset="6">
            注：该环保审核结果仅适用于转入苏州大市，如若该车辆迁出苏州，则此审核单失效，以迁入地的排放认定为准。
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" :offset="6"
            ><button @click="back" class="btn">返回</button></el-col
          >
          <el-col :span="6" :offset="1"
            ><button class="btn" @click="print">打印</button></el-col
          >
        </el-row>
      </div>
      <div v-if="carInfo.yy" class="Return">
        <img src="../assets/叉.png" alt="" />
        <h3>已认定</h3>
        <p>原因：{{ carInfo.yy }}</p>
        <p>状态：{{ carInfo.zt }}</p>
        <el-row>
          <el-col :span="8" :offset="8"
            ><button @click="back" class="btn">返回</button></el-col
          >
          <el-col :span="8" :offset="8"
            ><button @click="resubmit" class="btn">重新提交</button></el-col
          >
        </el-row>
      </div>

      <div class="dp">
        <div id="printTable" ref="print" style="background: red">
          <h3>苏州市机动车排放阶段环保审核单（单车）</h3>
          <p class="indent">苏州市公安局交通警察支队车辆管理所:</p>
          <p class="indent">
            经我局确认，整车型号为<span>{{ carInfo.zcxh }}</span
            >、发动机型号为<span>{{ carInfo.fdjxh }}</span
            >、生产（制造）年月为<span>{{ carInfo.ccrq }}</span
            >、生产厂商为<span>{{ carInfo.sccs }}</span
            >的机动车，符合国家<span>{{ carInfo.rdbz }}</span
            >排放阶段，具体情况见下表:
          </p>
          <table>
            <tr>
              <td class="ft">所有人/销售单位</td>
              <td colspan="3">{{ carInfo.tjr }}</td>
            </tr>
            <tr>
              <td colspan="2">身份证明号码／营业执照</td>
              <td colspan="2">{{ carInfo.sfzmhm }}</td>
            </tr>
            <tr>
              <td>整车型号</td>
              <td>{{ carInfo.zcxh }}</td>
              <td>发动机型号</td>
              <td>{{ carInfo.fdjxh }}</td>
            </tr>
            <tr>
              <td>车辆识别代号</td>
              <td colspan="3">{{ carInfo.clsbdh }}</td>
            </tr>
            <tr>
              <td>环保随车清单信息公开编号</td>
              <td colspan="3">{{ carInfo.scqdbh }}</td>
            </tr>
            <tr>
              <td>生产（制造）年月</td>
              <td colspan="3">{{ carInfo.ccrq }}</td>
            </tr>
            <tr>
              <td>排放标准</td>
              <td colspan="3">{{ carInfo.rdbz }}</td>
            </tr>
            <tr>
              <td>经办人</td>
              <td>{{ carInfo.shrxm }}</td>
              <td>审核认定日期</td>
              <td>{{ carInfo.rdsj }}</td>
            </tr>
          </table>
          <p class="indent">注：请车主携此确认单至车管所各分所办理登记业务。</p>
          <p class="indent" style="position: absolute">
            该环保审核结果仅适用于转入苏州大市，如若该车辆迁出苏州，则此审核单失效，以迁入地的排放认定为准。
          </p>
          <p class="right mt">经办人：{{ carInfo.shrxm }}</p>
          <p class="right">确认单打印时间：{{ currentDate }}</p>
          <div id="qrcode2"></div>
        </div>
      </div>

      <!-- <button @click="close" class="btn">打印</button> -->
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2"; // 引入qrcode
export default {
  name: "result1",
  data() {
    return {
      isPc: false,
      code: "123456",
      msg: "您的车辆已认定",
      carInfo: {},
      currentDate: "",
    };
  },
  methods: {
    //关闭
    close() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        WeixinJSBridge.call("closeWindow");
      } else {
        window.opener = null;
        window.open("", "_self");
        window.close();
      }
    },
    // 打印
    print() {
      // this.$refs['printInspection'].barcodeInit(format);    // 条形码

      this.$print(this.$refs.print); // 打印
    },
    back() {
      window.history.go(-1);
    },
    resubmit() {
      console.log("重新提交");
      let lsh = this.carInfo.lsh;
      let params = { lsh };
      this.$get("/fLow/queryWhenResubmit", params).then((response) => {
        if (response.status != "1") {
          if (that.isPc) {
            return that.$root.$children[0].vueAlert1(response.msg);
          } else {
            return that.$root.$children[0].vueAlert(response.msg);
          }
        }
        // localStorage.setItem("resubmit",JSON.stringify(response.data))
        this.$router.push({ name: "submit", params: { ...response.data } });
      });
    },
  },
  mounted() {
    this.isPc = window.innerWidth > 640 ? true : false;
    this.carInfo = JSON.parse(localStorage.getItem("searchResult"));
    // console.log(this.carInfo);
    this.currentDate = this.$root.$children[0].timeFomat(
      "yyyy.MM.dd",
      new Date()
    );
    if (!this.carInfo.yy) {
      let id = this.isPc ? "qrcode1" : "qrcode";
      let qrcode = new QRCode(id, {
        width: 150,
        height: 150,
        text: this.carInfo.ewm, // 二维码地址
        colorDark: "#000",
        colorLight: "#fff",
      });
      let qrcode1 = new QRCode("qrcode2", {
        width: 150,
        height: 150,
        text: this.carInfo.ewm, // 二维码地址
        colorDark: "#000",
        colorLight: "#fff",
      });
    }
  },
};
</script>
<style scoped>
@media only screen and (min-width: 640px) {
  .result1 {
    height: 100vh;
  }
}
.phone {
  position: relative;
  /* height: 76vh; */
  padding: 20vh 10vw 4vh 10vw;
}
.img {
  width: 40%;
}
h3 {
  font-size: 18px;
  text-align: center;
}
p {
  font-size: 3vh;
  text-align: left;
  line-height: 4.5vh;
}
h1 {
  font-size: 10vh;
  line-height: 24vh;
  color: rgb(0, 198, 49);
}
.phone .btn {
  width: 90vw;
  position: absolute;
  bottom: 6vh;
  left: 5vw;
}
.phone .back {
  bottom: -2vh;
}
.phone .resubmit {
  bottom: 14vh;
}
.phone > div {
  padding-bottom: 12vh;
}
.pc {
  width: 50vw;
  padding: 2.5vh;
  margin: 10vh 22.5vw;
  background: #fff;
}
#qrcode {
  width: 150px;
  height: 150px;
  position: relative;
  margin: 10px auto;
}
#qrcode1 {
  width: 150px;
  height: 150px;
  position: relative;
  margin: 10px auto;
}
.pc p {
  padding-left: 15vw;
}
.pc .Return p {
  padding-left: 10vw;
}
.pc .btn {
  margin-top: 4vh;
}
.pc .img {
  width: 20%;
}
.dp {
  display: none;
}
.dp h3 {
  text-align: center;
}
@page {
  size: A4;
  padding: 2cm;
  margin: 2cm 0.5cm 0.5cm 1.5cm;
}
#printTable {
  position: relative;
  font-weight: 320;
  font-size: 12px;
  font-family: "宋体";
  margin: 0 8px;
  color: #000;
}
#printTable h4 {
  font-size: 12px;
  line-height: 40px;
  text-align: center;
  margin-bottom: 20px;
}
#printTable p {
  font-size: 12px;
  line-height: 40px;
}
#printTable p span {
  padding: 0 10px;
  text-decoration: underline;
}
#printTable p.indent {
  text-indent: 30px;
  font-size: 14px;
}
#printTable table {
  width: 100%;
  text-align: center;
  margin: 25px 0;
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  font-size: 12px;
  line-height: 30px;
}
#printTable table td {
  border-left: 1px solid #000;
  border-top: 1px solid #000;
}
#printTable p.right {
  text-align: right;
  padding-right: 40px;
}
.mt {
  margin-top: 75px;
}
.ft {
  width: 200px;
}
</style>
